import React, { Component } from "react";

import {
  Icon,
  Modal,
  Header,
  Input,
  Button,
  Grid,
  Popup,
} from "semantic-ui-react";

class CreateDerivative extends Component {
  constructor() {
    super();
    this.state = {
     
    };
  }
  genmsg() {
    var msg;
    if (this.state.created === true) {
      msg =
        this.state.newwonton +
        " Has been created with a budget of $" +
        this.state.newbudget +
        ".";
    } else if (this.state.created === false && this.props.wod !== null) {
      msg = "Enter the budget of New Derivative " + this.props.wod.workOrderNbr;
    }
    return msg;
  }
  genfiles() {
    if (this.props.wod.files && this.props.wod.files.length) {
      return (
        <ul>
          {this.props.wod.files.map((file) => (
            <Popup
              flowing
              hoverable
              trigger={
                <li>
                  <a href={file.url} target="_blank">
                    {file.filename}
                  </a>
                </li>
              }
            >
              <Button
                basic
                color="red"
                onClick={() => this.props.deletefile(file.id)}
              >
                <Icon name="remove" /> Delete File
              </Button>
            </Popup>
          ))}
        </ul>
      );
    } else {
      return <h5>This Workorder has no files.</h5>;
    }
  }
  fileupdate(e) {
    if (e.target.files) {
      var file = e.target.files[0]
      //filter files to those that arnt already attached
      this.setState({ newfile: file });
    }
  }
  genbtns() {
    if (this.state.created === false) {
      return (
        <div>
          <Button basic color="red" inverted>
            <Icon name="remove" /> Cancel
          </Button>
          <Button
            color="green"
            inverted
            onClick={() => {
              if (this.state.newbudget !== null) {
                this.props.handlecreatederiv(this.state.newbudget);
              }
            }}
          >
            <Icon name="checkmark" /> Add Files
          </Button>
        </div>
      );
    } else {
      return (
        <Button color="blue" inverted>
          <Icon name="checkmark" /> Exit
        </Button>
      );
    }
  }
  render() {
    return (
      <div className="CreateDerivative">
        <Modal
          basic
          open={this.props.showModal}
          onClose={() => this.props.closemodal()}
          closeOnEscape
          size="large"
          closeOnRootNodeClick={false}
        >
          <Header textAlign="center">{this.genmsg()}</Header>
          <Modal.Content>
            <Grid>
              <Grid.Row centered>
                <p>Attached Workorder Files</p>
              </Grid.Row>
              <Grid.Row centered>
                <Input
                  icon="file"
                  iconPosition="left"
                  type="file"
                  onChange={(e) => this.fileupdate(e)}
                />
                <Button
                  color="green"
                  inverted
                  onClick={() => {
                    this.props.uploadFiles(this.state.newfile);
                  }}
                >
                  <Icon name="checkmark" /> Add Files
                </Button>
              </Grid.Row>
              <Grid.Row>{this.genfiles()}</Grid.Row>
            </Grid>
          </Modal.Content>
          {/* <Modal.Actions>{this.genbtns()}</Modal.Actions> */}
        </Modal>
      </div>
    );
  }
}

export default CreateDerivative;



// WEBPACK FOOTER //
// ./src/components/wod/filemodal.jsx